import SportCode from 'components/common/SportCode';
import Pbp from 'components/general/Pbp'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const HocCenterRender = ({ action }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  let [a, b, c] = ['', '', ''];

  if (action.competitors === undefined) {
    a = <div><SportCode discipline={mirs_discipline} entity='@ActionComment' code={action?.pbpa_Comment} /></div>
  }

  if (!action?.pbpa_Comment?.includes('ENDP') && !action?.pbpa_Comment?.includes('STARTP')) {
    b = <div>{action?.pbpa_When}</div>
  }

  if (action.pbpa_SO_H) {
    c = <div><strong>{action?.pbpa_SO_H} - {action?.pbpa_SO_A}</strong></div>
  } else if (action.pbpa_ScoreH) {
    c = <div><strong>{action?.pbpa_ScoreH} - {action?.pbpa_ScoreA}</strong></div>
  }

  return (<div className='box-center text-center'><strong>{a}{b}{c}</strong></div>);
}

function HocPbp({ data, periodsOrder }) {

  const configPpb = {
    centerRender: HocCenterRender,
    headerRender: () => { },
    layout: "points_left",
    periodsOrder: periodsOrder,
    reverseSorting: true
  }

  return (<>
    <Pbp data={data} config={configPpb} />
  </>);
}

export default HocPbp;